import { Download, FileText } from "lucide-react";
import Reveal from "../components/landing/Reveal";
import Seo from "../components/site/Seo";
import { useLanguage } from "@/i18n/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Gallery({ title, basePath, count, prefix, testid }) {
  return (
    <div className="mt-14">
      <p className="kicker">{title}</p>
      <div className="mt-5 flex gap-4 overflow-x-auto pb-4" data-testid={testid}>
        {Array.from({ length: count }, (_, i) => {
          const src = `${basePath}/${prefix}-${String(i + 1).padStart(2, "0")}.jpg`;
          return (
            <a
              key={src}
              href={src}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`${testid}-item-${i + 1}`}
              className="shrink-0"
            >
              <img
                src={src}
                alt={`${title} ${i + 1}`}
                loading="lazy"
                className="h-44 w-auto border border-forest-800/25 transition-colors hover:border-ember"
              />
            </a>
          );
        })}
      </div>
    </div>
  );
}

export default function DocumentosPage() {
  const { t, lang } = useLanguage();

  return (
    <main className="bg-cream pb-24 pt-28 md:pt-36" data-testid="documentos-page">
      <Seo
        title={lang === "es" ? "Documentos y dossier comercial — WasteData" : "Documenti e dossier commerciale — WasteData"}
        description={t.documentos.sub}
        path="/documentos"
      />
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <a href="/" data-testid="documentos-back" className="text-sm font-semibold text-ember hover:underline">
          {t.documentos.back}
        </a>

        <Reveal>
          <h1 className="mt-6 font-display text-4xl font-bold tracking-tight text-forest-800 md:text-5xl" data-testid="documentos-title">
            {t.documentos.title}
          </h1>
          <p className="mt-4 max-w-2xl text-base text-forest-800/75">{t.documentos.sub}</p>
          <div className="mt-6 h-px w-24 bg-forest-800" aria-hidden="true" />
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {t.documentos.docs.map((doc, index) => (
            <Reveal key={doc.file} delay={index * 0.1}>
              <article className="card-lift flex h-full flex-col border border-forest-800/30 bg-white p-7" data-testid={`doc-card-${doc.file}`}>
                <FileText className="text-ember" size={26} strokeWidth={1.5} />
                <h2 className="mt-4 font-display text-xl font-bold text-forest-800">{doc.name}</h2>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-forest-800/70">{doc.desc}</p>
                <p className="mt-4 font-mono text-xs text-forest-800/50">PDF · {doc.size}</p>
                <a
                  href={`${API}/brochure?doc=${doc.file}`}
                  data-testid={`doc-download-${doc.file}`}
                  className="mt-5 inline-flex items-center justify-center gap-2 bg-forest-800 px-5 py-3 text-sm font-bold text-cream transition-colors hover:bg-forest-700"
                >
                  <Download size={16} /> {t.documentos.download}
                </a>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <Gallery
            title={t.documentos.galleryDossier}
            basePath="/assets/dossier"
            count={10}
            prefix="page"
            testid="gallery-dossier"
          />
        </Reveal>
        <Reveal>
          <Gallery
            title={t.documentos.galleryDeck}
            basePath="/assets/deck"
            count={15}
            prefix="slide"
            testid="gallery-deck"
          />
        </Reveal>
      </div>
    </main>
  );
}
